import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AnimationOptions } from 'ngx-lottie';
import { Subscription } from 'rxjs';
import { LottieService } from 'src/app/service/animations/lottie.service';
import { UsuarioServiceProvider } from 'src/app/service/index.providers';

@Component({
  selector: 'app-checklist-details',
  templateUrl: './checklist-details.component.html',
  styleUrls: ['./checklist-details.component.scss'],
})
export class ChecklistDetailsComponent  implements OnInit {

 @Input() eventName:string;
 @Input() eventType:string;
 @Input() address:string;
 @Input() displayIntegrationButton:boolean = true;
 @Input() eventIsLocked:boolean = true;
 @Input() dateEventStart: Date;
 @Input() dateEventEnd: Date;
 @Input() eventIsSynced: boolean;

 coinOptions: AnimationOptions | null = null;
 topicActiveIdx = [];
 teaserIsPlaying:boolean = false;
 usuario: any;
 hasCalendarIntegrationAvailable: boolean;
 private userDataSub: Subscription;
  constructor(
    private modalCtrl: ModalController,
    private lottieService: LottieService,
    private up: UsuarioServiceProvider,
  ) { }

  ngOnInit() {
    this.setAnimations();
    this.userDataSub = this.up.data_usuario$.subscribe((data) => {
        this.usuario = data;
        this.hasCalendarIntegrationAvailable = this.usuario?.has_calendar_integration;
        // console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!User data:", this.usuario);
    });

  }

  onClickBtn(response) {
    // e.stopPropagation();
    this.modalCtrl.dismiss(response);
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  setAnimations() {
    this.coinOptions = this.lottieService._coinOptions;
  }

  openTopicDetail(topicIndex) {
    if( this.topicActiveIdx.includes(topicIndex) ) {
      this.topicActiveIdx = this.topicActiveIdx.filter( idx => idx !== topicIndex);
    } else {
      this.topicActiveIdx.push(topicIndex);
    };
  }

  sendCalendarEvent() {
    this.modalCtrl.dismiss( "integrateCalendarEvent");
  }

   ngOnDestroy() {
    if(this.userDataSub) this.userDataSub.unsubscribe();
  }

}
